/**
 * The bedroom programme's tunables. One table, like `../constants.js` for the
 * bathroom; each number says whether it is measured, sourced or a choice.
 *
 * Corpus figures are the committed emulator corpus, measured 2026-10-28: 64
 * rooms with a `bed`, 76 beds.
 */

const IN = 0.0254;

/**
 * The bed's HEAD stands against the parallel wall within this gap. Measured:
 * 72 of 76 corpus beds within 11 in, three more at 13-16 in, and one floating
 * 173 in from any wall. A choice above that cluster.
 */
const HEAD_WALL_GAP_M = 18 * IN;
/** A wall counts as parallel to the headboard when |cos| of the angle is over this. */
const HEAD_WALL_PARALLEL = 0.9;

/**
 * A NIGHTSTAND is a `storage` or `table` piece beside the head of the bed.
 * Measured on the corpus: 49 of 64 bed rooms have one, and every such piece's
 * centre is 2-19 in from the head end, its near edge within 6 in of the bed's
 * side (overlapping by up to 6, a scan's slack), 11-33 in wide and 17-33 in
 * tall. Pieces outside that — a 51-58 in desk 12 in off a bed's side, a
 * dresser at its foot — are furniture the kit does not dress.
 */
const NIGHTSTAND_TYPES = new Set(['storage', 'table']);
const NIGHTSTAND_MAX_FROM_HEAD_M = 24 * IN;
const NIGHTSTAND_SIDE_GAP_M = [-6 * IN, 12 * IN];
const NIGHTSTAND_MAX_WIDTH_M = 36 * IN;
const NIGHTSTAND_HEIGHT_M = [15 * IN, 34 * IN];

/**
 * The walkway beside and across the foot of a bed. Design guides give 24 in as
 * the least for a side used nightly and 30-36 in as comfortable
 * (mattressnut.com "bedroom furniture spacing"; engineerfix.com, "space
 * between a bed and dresser"). The least, because a staged prop must not
 * be the thing that makes a tight room fail it. The olive tree keeps out of
 * it; the rug may run under it.
 */
const BED_WALKWAY_M = 24 * IN;

/** A rug corner may overhang the floor outline by this much (scan slack). */
const RUG_FLOOR_SLACK_M = 1 * IN;

/** The olive tree stands this far off the walls it is cornered by. */
const FLOOR_PLANT_WALL_GAP_M = 2 * IN;

module.exports = {
  HEAD_WALL_GAP_M,
  HEAD_WALL_PARALLEL,
  NIGHTSTAND_TYPES,
  NIGHTSTAND_MAX_FROM_HEAD_M,
  NIGHTSTAND_SIDE_GAP_M,
  NIGHTSTAND_MAX_WIDTH_M,
  NIGHTSTAND_HEIGHT_M,
  BED_WALKWAY_M,
  RUG_FLOOR_SLACK_M,
  FLOOR_PLANT_WALL_GAP_M,
};
